// Main js file
import './components/ageGate';
import './components/formQuiz';
import './components/scrollBar';
import './components/tooltip';
import './components/slider';

document.addEventListener('DOMContentLoaded', () => {
    window.addEventListener('resize', () => {
        window.headerHeight();
        window.footerHeight();
    });
});

// Mob menu
(function () {
    let trigger = document.querySelector('.js-menu-trigger'),
        mobMenu = document.querySelector('.js-lang-switch');
    if (trigger) {
        document.addEventListener('click', function (event) {
            if (mobMenu && document.body.classList.contains('menu-open')) {
                var isClickInside = mobMenu.contains(event.target);
                if (!isClickInside && !trigger.contains(event.target)) {
                    document.body.classList.remove('menu-open');
                }
            }
        });
        trigger.onclick = () => {
            document.body.classList.toggle('menu-open');
        };
    }
})();

// Get current time in Belgium
const belgiumTime = new Date(new Date().toLocaleString("en-US", {
    timeZone: "Europe/Brussels"
}));
const hours = belgiumTime.getHours();
const minutes = belgiumTime.getMinutes();

// Getting block elements
const firstBlock = document.getElementById('headerCounter');
const secondBlock = document.getElementById('headerShield');

function updateTimer() {
    var currentTime = new Date(new Date().toLocaleString("en-US", {
        timeZone: "Europe/Brussels"
    }));
    var currentHour = currentTime.getHours();
    var currentMinutes = currentTime.getMinutes();
    var currentSeconds = currentTime.getSeconds();

    // Calculation of start and end of time slot
    var slotDuration = 60 * ((21 - 9) / 8); // Slot duration in minutes
    var dayStart = 9 * 60; // Start of the working day in minutes from midnight
    var dayEnd = 21 * 60; // End of working day in minutes from midnight
    var minutesSinceDayStart = currentHour * 60 + currentMinutes;

    // If the current time is outside the working hours, stop the timer
    if (minutesSinceDayStart < dayStart || minutesSinceDayStart >= dayEnd) {
        return;
    }

    // Calculation of current slot
    var currentSlot = Math.floor((minutesSinceDayStart - dayStart) / slotDuration);
    var slotStart = dayStart + currentSlot * slotDuration;
    var slotEnd = slotStart + slotDuration;

    //  Calculation of the remaining time to the end of the slot in seconds
    var timeLeft = slotEnd * 60 - (minutesSinceDayStart * 60 + currentSeconds);

    // Updating timer on the page
    const displayMinutes = document.querySelector('.timer__minutes');
    const displaySeconds = document.querySelector('.timer__seconds');
    displayMinutes.textContent = String(Math.floor(timeLeft / 60)).padStart(2, '0');
    displaySeconds.textContent = String(Math.floor(timeLeft % 60)).padStart(2, '0');
}

if (!!firstBlock && !!secondBlock) {
    // Set the display of blocks based on time
    if ((hours === 9 && minutes >= 0) || (hours > 9 && hours < 20) || (hours === 20 && minutes < 59)) {
        // If the time is from 9:00 to 20:59, show the first block and hide the second block
        firstBlock.classList.remove('hidden');
        secondBlock.classList.add('hidden');
    } else {
        // If the time is from 21:00 to 8:59, hide the first block and show the second one.
        firstBlock.classList.add('hidden');
        secondBlock.classList.remove('hidden');
    }

    // Run updateTimer function every second
    setInterval(updateTimer, 1000);
}